import { RootState } from "../reducers";

export const getChatActive = ({ chat }: RootState) => chat.active;

export const getChatWidth = ({ chat }: RootState) => chat.width;
